import { AGENT_TONE_DEFAULT_STATE } from "./config";

export function createRequestId(prefix = "req") {
  return `${prefix}-${Date.now()}`;
}

export function createGeneratePayload(formState) {
  return {
    request_id: formState.request_id || createRequestId("tone"),
    mode: formState.mode,
    tone: { ...formState.tone },
    personality_type: formState.personality_type,
    brand_voice: formState.brand_voice,
    communication_style: formState.communication_style,
    greeting_style: formState.greeting_style,
    question_asking_style: formState.question_asking_style,
    closing_style: formState.closing_style,
    error_handling_style: formState.error_handling_style,
    apology_level: formState.apology_level,
    hedging_level: formState.hedging_level,
    instruction_vs_explanation_preference:
      formState.instruction_vs_explanation_preference,
    user_expertise_level: formState.user_expertise_level,
    industry_domain: formState.industry_domain,
    use_case_type: formState.use_case_type,
    toggles: { ...formState.toggles },
    output: { ...formState.output },
    custom_instructions: formState.custom_instructions || "",
  };
}

export function getToneAverage(tone) {
  const values = Object.values(tone || {});
  if (!values.length) return 0;
  return Math.round(values.reduce((sum, value) => sum + Number(value || 0), 0) / values.length);
}

export function getEnabledToggleCount(toggles) {
  return Object.values(toggles || {}).filter(Boolean).length;
}

export function cloneDefaultAgentToneState() {
  return JSON.parse(JSON.stringify(AGENT_TONE_DEFAULT_STATE));
}
